import MuiGrid, { GridProps } from "@mui/material/Grid";

const Grid: React.FC<GridProps> = (props) => <MuiGrid {...props} />;

export default Grid;
